import { render, staticRenderFns } from "./BaseUserLink.vue?vue&type=template&id=32cd89a0&scoped=true"
import script from "./BaseUserLink.vue?vue&type=script&lang=js"
export * from "./BaseUserLink.vue?vue&type=script&lang=js"
import style0 from "./BaseUserLink.vue?vue&type=style&index=0&id=32cd89a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd89a0",
  null
  
)

export default component.exports